import React from "react";
import { Button } from "../ui/button";

export function OrderTotal({ isSticker, total, form, submitting }) {
  if (!isSticker) {
    return (
      <div className="pt-2 flex flex-wrap gap-3 justify-end items-center">
        <div className="text-xs text-[color:var(--text-muted)] mr-auto">No payment taken now — we'll quote you within 24h.</div>
        <Button data-testid="submit-order" type="submit" disabled={submitting} className="btn-primary rounded-full px-8 py-6">{submitting ? "Submitting…" : "Request my quote"}</Button>
      </div>
    );
  }
  return (
      <>
        <div data-testid="order-total" className="flex items-baseline justify-between pt-2 border-t hairline">
          <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--text-muted)]">Total due today</div>
          <div className="font-serif text-3xl" style={{color: "var(--primary)"}}>
            ${total}
            {form.rush && <span className="ml-2 text-xs uppercase tracking-[0.2em]" style={{color: "var(--accent-metal)"}}>· Rush</span>}
            {form.military_discount && <span className="ml-2 text-xs uppercase tracking-[0.2em]" style={{color: "var(--accent-metal)"}}>· 10% Mil</span>}
          </div>
        </div>
        <div className="pt-2 flex flex-wrap gap-3 justify-end">
          <Button data-testid="submit-order" type="submit" disabled={submitting} className="btn-primary rounded-full px-8 py-6">{submitting ? "Creating…" : `Continue to secure payment — $${total}`}</Button>
        </div>
      </>
  );
}
